module.exports = __webpack_public_path__ + "static/media/favicon.3f5ab0aa.ico";


//////////////////
// WEBPACK FOOTER
// ./src/images/branding/nobrand/favicon.ico
// module id = 1387
// module chunks = 0